import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { RequesterRoleGate } from '@/components/auth/requester-role-gate';
import { OfferNewLayout } from '@/components/offer/new/offer-new-layout';

export const Route = createFileRoute('/_app/offers/new')({
  validateSearch: (search: Record<string, unknown>): { draftId?: string } =>
    typeof search.draftId === 'string' ? { draftId: search.draftId } : {},
  component: NewOfferPage,
});

function NewOfferPage(): React.ReactElement {
  const { draftId } = Route.useSearch();
  return (
    <RequesterRoleGate>
      <OfferNewLayout initialDraftId={draftId ?? null} />
    </RequesterRoleGate>
  );
}
